import * as Dialog from "@radix-ui/react-dialog";
import Close from "../../assets/svg/Close";

const BottomSheet = ({ open, onOpenChange, title, container, children }) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal container={container}>
        <Dialog.Overlay
          className="
            absolute inset-0 z-40 bg-black/40
            data-[state=open]:animate-fadeIn
            data-[state=closed]:animate-fadeOut
          "
        />

        <Dialog.Content
          className="
            absolute bottom-0 inset-x-0 z-50
            h-auto max-h-[80%] bg-slate-100 rounded-t-3xl
            focus:outline-none
            data-[state=open]:animate-sheetUp
            data-[state=closed]:animate-sheetDown
            flex flex-col
          "
        >
          <Dialog.Close asChild>
            <button
              className="absolute -top-14 left-1/2 -translate-x-1/2 rounded-full bg-[#000000] p-[10px] text-white flex items-center justify-center shadow-lg outline-none focus:outline-none focus-visible:outline-none focus-visible:ring-0 ring-0"
              aria-label="Close"
            >
              <Close size={18} />
            </button>
          </Dialog.Close>

          <div className="px-4 py-3 bg-white rounded-t-3xl">
            <h2 className="text-lg supreme-bold">{title}</h2>
          </div>

          <div className="h-full overflow-auto">{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default BottomSheet;
